// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2Z2Zp","legacyBtn":"MutateMid_legacyBtn__2st0r"};